const projectsImagesPath = process.env.PUBLIC_URL + '/project-images/';

// codeblocks may appear to be tabbed strange this is mandatory
const projects = [
{
  id: "1",
  techStack: ["SiHtml5", "SiCss3"],
  category: "HTML & CSS",
  title: 'Country Website',
  image: `${projectsImagesPath}canadian-flag.jpg`,
  brief_description: 'Static Website using HTML & CSS',
  single_link: `/project/1`,
  external_link: `https://patrickneil.ca/websites/coutnry-website/index.html`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/country-website/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/country-website/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/country-website/slide-003.png`
  },
  long_description: "This is my country website, it a multipage website where I describe the city of Montreal (I guess I should be calling it 'city website'). This demonstrates my usage of flexbox and CSS grid along with various CSS position attributes.",
  conclusion: "This project had more challenges than I thought it would, I may tweak some of the styles in the future for aesthetics but all in all I learned allot about CSS. Especially about how to make banner images and accessability"
},
{
  id: "2",
  techStack: ["SiJavascript", "SiSass"],
  category: "Javascript",
  title: 'Dice Game',
  image: `${projectsImagesPath}dice.png`,
  brief_description: 'A game built using Vanilla JS and SASS',
  single_link: `/project/2`,
  external_link: `https://patrickneil.ca/websites/comp-2132-javascript-dice-game/index.html`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/dice-game/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/dice-game/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/dice-game/slide-003.png`
  },
  long_description: "This is the first game I made in Javascript, (this project is made for desktop browsers) It is a game that calculates the addition of 2 dice roles vs a CPU opponent, after 3 rounds whoever has the better score wins. (rolling a 1 makes your roll worth a zero). This game was made using vanilla javascript and sass it was made before I started the FWD Program",
  conclusion: "From the get go I had a good idea of how the logic was going to go but I was relevely new to Sass and how to properly structure my CSS. This was my first game I made and I want to make more games in the future."
},
{
  id: "3",
  techStack: ["SiHtml5", "SiCss3"],
  category: "HTML & CSS",
  title: 'Food Bank Website',
  image: `${projectsImagesPath}food-basket.jpg`,
  brief_description: 'A website built using HTML & CSS',
  single_link: `/project/3`,
  external_link: `https://patrickneil.ca/websites/comp-1850-foodbank-website/final_project/index.html`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/food-bank/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/food-bank/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/food-bank/slide-003.png`
  },
  long_description: "This was my first multipage website, and thus was made before I learned javascript. it is a five page website demonstrating my usage of flexbox and form making. While there is no validation to the forms, it is a five page website demonstrating profficency in making complex layouts with flexbox the grassy logo was made by me using photoshop",
  moving_forward: "I made this site way before I learned anything about form validation or PHP, at the time of creation I only knew how to make and style forms. This said moving forward the obvious step will be to include some PHP and Javascript for form validation I chose a food bank because I like the idea of helping to make non-profit websites"
},
{
  id: "4",
  techStack: ["SiSass", "SiBootstrap"], 
  category: "HTML & CSS",
  title: `Patty's Pub`,
  image: `${projectsImagesPath}pub-banner-clipart.png`,
  brief_description: 'A Restaurant website built using Sass and Bootstrap',
  single_link: `/project/4`,
  external_link: `https://patrickneil.ca/websites/pub-website-web-dev-2/index.html`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/pattys-pub/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/pattys-pub/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/pattys-pub/slide-003.png`
  },
  long_description: "This is a project was a front page to a restaurant website, I decided to go the extra mile for the SASS on this one and really show my usage with bootstrap. I use various bootstrap menus and carousels here. Also this project was made making full use of SASS",
  conclusion: "I enjoyed making this site. I have an interest in food and this was a nice outlet for that. I enjoyed making the menu look elegant it was also nice to show my skill in bootstrap. If I had a real restaurant I would be pleased with this kind of front page."
},
{
  id: "5",
  techStack: ["SiHtml5", "SiCss3", "SiJavascript"],
  category: "Javascript",
  title: 'Space Adventure',
  image: `${projectsImagesPath}rocketship-clipart.png`,
  brief_description: 'A browser game built using Vanilla Javascript',
  single_link: `/project/5`,
  external_link: `https://patrickneil.ca/websites/patrick-neil-game-project/index.html`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/space-adventure/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/space-adventure/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/space-adventure/slide-003.png`
  },
  long_description: "The Project is a video game that's meant to showcase my usage of vanilla Javascript. This was done by making and arcade like game. Where the play moves a rocketship to dodge rocks flying at the screen towards the player. They player must move away from the rocks and stay in the game as long as possibe.",
  code_block: {
    text: `moveRocks(){
  //if the game is running iterate over the game obstacles array and move every rock down by changing the css value for top
  if (this.isRunning === true){
      let i = 0;
      for (i = 0; i < this.obstacles.length; i++){
          let rock = this.obstacles[i]; //assign rock to the current rock being processed
          //Increase the top of each rock that exists on the board
          let rockTop = parseInt(window.getComputedStyle(rock).getPropertyValue('top')); 
          rock.style.top = rockTop + this.gameSettings.obstacleFallSpeed + 'px'; // move every rock down by changing the css top value

          if (rockTop >= this.gameSettings.gameboardHeight) {
              this.gameArea.removeChild(rock); // if the currently processed rock is passed the gameboard remove it

              //score is based on how many rocks have been passed by the player if they passed the gameboard then they passed the player
              this.player.score++;
              this.scoreArea.innerHTML = 'Score' + ' ' + this.player.score;
          }
      }
    }
},`,
    language: `javascript`,
    explanation: "This is the code in my project that makes the rocks fall towards the player. This function checks the position of every rock in my array and increases the CSS top value by a variable that I set in pixels. once it goes passed the gameboard area I remove the element entirely. Each of these rocks is a div element"
  },moving_forward: "Allot of work went into this javascript project and if you look in my code you will see that everything is commented clearly and concisely. I like games so I went the extra mile for this one, However there were certain features that I wanted to add that were cut due to time contraints, in the future like background music and smoother sprite movement."
},
{
  id: "6",
  techStack: ["SiJavascript", "SiReact"],
  category: "React",
  title: 'Calculator App',
  image: `${projectsImagesPath}calculator-clipart.jpg`,
  brief_description: 'A Calculator Built using the React.js Framework.',
  single_link: `/project/6`,
  external_link: `https://patrickneil.ca/websites/calculator-app`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/calculator-app/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/calculator-app/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/calculator-app/slide-003.png`
  },
  long_description: "This was a group Project Built on react. The Goal was to build a calculator using the react.js frame work. The Calculator has several of the features you would see in a regular calculator like, Addition, Subtraction, Multiplication, Divition, Percentage, Square root and even Memory Buttons",
  code_block: {
  text: `function changeSign() {
// if the number is 0, make button not working
// if nothing, make button not working
// if there is a ‘-’ starting from the index 1, make button not working
if (calc === '0' || calc === '' || calc.includes('-', 1)) {
  return;
}

if (
  !calc.includes('+') &&
  (!calc.includes('-') || calc.charAt(0) === '-')&&
  !calc.includes('*') &&
  !calc.includes('/')
) {
  setCalc(evaluate(-1*calc).toString());
  setResult(evaluate(-1*calc).toString());
}
}`,
    language: `javascript`,
    explanation: "This block of code is meant to change the current number from positive to negative and vice versa. It works by checking the current sign that's present on the number and where in the string it is. if it's a negative already it multiples the number by -1 because a negative number times a negative number is a positive number."
  },conclusion: "At this point I was wanting to work more on team projects and this project seem like a good place to start, I am happy with how we coordinated to make the calculator both sleek and functional."
},
{
  id: "7",
  techStack: ["SiAdobephotoshop", "SiAdobexd"], 
  category: "Design",
  title: `Movie Database Mockup`,
  image: `${projectsImagesPath}movie-database.png`,
  brief_description: 'A working prototype for a movie database website. made in Adobe Photoshop and exported to Adobe XD.',
  single_link: `/project/7`,
  external_link: `https://xd.adobe.com/view/73b07305-46f7-4eee-bdef-c76543a233ec-26e3/`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/movie-mockup/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/movie-mockup/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/movie-mockup/slide-003.png`
  },
  long_description: "This project started with a wireframe and ideas for branding It was made into a mockup in photoshop then exported to Adobe XD to make a functioning prototype. This was the design choosen for the movie database project in react made by a team of me and 4 other people.",
  design_process: ["I researched into color schemes and thought of the branding for it. I found that purple was most associated to luxury. which is the kind of feeling one would want to feel when kicking back and watching a nice movie", "I used layer masking to make the posters in photoshop, they were scaled to size using the free transform tool. Eventually the mockup was finished", "I exported this project to Adobe XD the used the XD component tool to create the look and feel of the website"],conclusion: "It is important to understand the process of web design in the workplace. A project almost never starts with a blank VS code window and this project pushed that point home. In the real world you start with a wireframe, that you make into a mockup or a prototype."
},
{
  id: "8",
  techStack: ["SiJavascript", "SiReact", "SiSass"],
  category: "React",
  title: 'Groovy Movies',
  image: `${projectsImagesPath}groovy-movies.png`,
  brief_description: 'An Website the performs API calls to fetch and render data',
  single_link: `/project/8`,
  external_link: `https://patrickneil.ca/websites/groovy-movies`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/groovy-movies/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/groovy-movies/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/groovy-movies/slide-003.png`
  },
  long_description: "This was the final project of my FWD React course it is a movie database that fetches data from an API and renders that data on the screen. It has many features like saving favorites to local storage as well as a search feature",
  code_block: {
  text: `useEffect(() => {

if (query === null || query === '') {
    return;
};

const queryURIEncoded = encodeURIComponent(query);

async function fetchMovies(q) {
    const res = await fetch('https://api.themoviedb.org/3/search/movie?api_key=' + API_KEY + '&language=en-US&query=' + q + '&page=1&include_adult=false');
    let data = await res.json();
    let first12Movies = data.results.splice(0, 12);
    setMovieData(first12Movies);
}

fetchMovies(queryURIEncoded);

}, [query]);`,
    language: `javascript`,
    explanation: "This block of code is meant for fetching the API data. This code block is foundational to how this app works. The App waits for the data be be grabbed, when it is it's in JSON format (Javascript object Notation) The Data is spliced to only include 12 movies then is it set the the MovieData object which is passed as a prop for rendering additional movies"
  },conclusion: "This was as much of a team coordination exercise as it was a react exercise it required very good teamwork, expertise and coordination. The favorites and search feature was quite a challenge."
},
{
  id: "9",
  techStack: ["SiWordpress", "SiWoo", "SiPhp"],
  category: "WordPress",
  title: 'Tranquil Tofino Cabins',
  image: `${projectsImagesPath}capstone-logo.png`,
  brief_description: 'Vacation Cabin Rental website built on WordPress and WooCommerce.',
  single_link: `/project/9`,
  external_link: `https://tranquiltofino.bcitwebdeveloper.ca/`,
  slide_show: {
    slide_1: `${projectsImagesPath}slide-shows/tranquil-tofino-cabins/slide-001.png`,
    slide_2: `${projectsImagesPath}slide-shows/tranquil-tofino-cabins/slide-002.png`,
    slide_3: `${projectsImagesPath}slide-shows/tranquil-tofino-cabins/slide-003.png`
  },
  long_description: "This was my capstone project for the FWD Program, it is a showcase of what I’ve learned throughout the program. It is a vacation cabin rental website built on WordPress and WooCommerce the functionality of the website is built using both PHP and JavaScript. Trello was used to manage the project and all the meetings that took page. I was the lead coordinator for this project.",
  code_block: {
  text: `<section class="map-with-multiple-markers-section">
  <h2 class="catalog-page-section-heading">Our Locations</h2>

  <?php
  $args = array(
      'post_type' => 'product',
      'post_per_page' => -1,
      //output all items in the web taxonomy (must be done as a 2D array)
      'tax_query' => array(
          array(
              'taxonomy' => 'product_cat',
              'field'    => 'slug',
              'terms'    => 'cabins',
          ),
      ),
  );
  $query = new WP_Query($args);
  if ($query->have_posts()) {
  ?>
      <div class="acf-map" data-zoom="16">
          <?php while ($query->have_posts()) {
              $query->the_post();
              $location = get_field('google_map');

              if ($location) : ?>
                  <div class="marker" data-lat="<?php echo esc_attr($location['lat']); ?>" data-lng="<?php echo esc_attr($location['lng']); ?>">

                      <div class="map-marker-flex">

                          <div class="map-marker-image">
                              <?php
                              // Add featured image to the map pin bubble
                              if (has_post_thumbnail()) {
                                  the_post_thumbnail('thumbnail');
                              }
                              ?>

                          </div>

                          <div class="map-marker-text">
                              <!-- Add a cabin link with the cabin title to the map pin bubble-->
                              <a href="<?php the_permalink(); ?>" title="<?php the_title_attribute(); ?>"><?php the_title(); ?></a>

                              <?php
                              $address = '';
                              foreach (array('street_number', 'street_name', 'city', 'state', 'post_code', 'country') as $i => $k) {
                                  if (isset($location[$k])) {
                                      $address .= sprintf('<span class="segment-%s">%s</span>, ', $k, $location[$k]);
                                  }
                              }

                              // Trim trailing comma
                              $address = trim($address, ', ');

                              // Display HTML.
                              echo '<p>' . $address . '.</p>' // display address to the map pin bubble;
                              ?>
                          </div>
                      </div>
                  </div>
      <?php endif;
          } // End While
      } // End Querry 
      wp_reset_postdata();
      ?>
</section>`,
    language: `php`,
    explanation: "This block of code is a taxonomy query that is meant to gather the data for all the locations of the cabins (entered by the client) and render them all onto a google map. JavaScript is used to do a fetch request using a google maps api key and this php script is used to render that data."
  },conclusion: "There were many challenges in this progress and even some of the things that one would think were very little were actually quite challenging. When I completed this project I started to notice what used to take days when I was learning took just hours to do. Many technologies were used to create this project and I am very proud of it."
},
];

export default projects;